module.exports = require("@swa-ui/loyalty");